// extracted by mini-css-extract-plugin
export default {"like":"like_like__IXCmb","loading":"like_loading__vPy49","spinner":"like_spinner__mo-GN","spin":"like_spin__kqCHy"};